module.exports = __webpack_public_path__ + "img/icon8.f9696c6a.png";